import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromMapping from '../reducers/mapping.reducer';
import { ViewRef } from '@angular/core';

const getMappingState = createSelector(fromFeature.getProductsState, (state: fromFeature.DashboardState) => state.mapper);

const getMappingEntities = createSelector(getMappingState, fromMapping.getMapping);

export const getMappings = createSelector(getMappingEntities, (entities) => {
  return entities;
});

export const getMasterModel = createSelector(getMappingState, fromMapping.getMasterModel);

export const getMappingOptions = createSelector(getMappingState, fromMapping.getMappingOptions);
export const getMappingSetup = createSelector(getMappingState, fromMapping.getMappingSetup);
export const getViewer = createSelector(getMappingState, fromMapping.getViewer);

export const getMappingTokens = createSelector(getViewer, (viewer) => {
  return viewer.mappingModelsView;
});

export const getMasterModelToken = createSelector(getViewer, (viewer) => {
  return viewer.masterModelView;
});

// export const getMappings = createSelector(getMappingState, fromMapping.getMapping, (mappings) => {
//   return mappings;
// });
